module.exports = __webpack_public_path__ + "img/logo.31b3b640.png";